<section id="about" class="relative py-24 sm:py-32 bg-surface-50">
  <div class="absolute inset-0 -z-10">
    <div class="absolute top-0 right-0 w-64 h-64 bg-accent/3 blur-3xl rounded-full"></div>
  </div>
  <div class="container mx-auto px-6 lg:px-10">
    <!-- Section header -->
    <div class="flex items-center gap-4 mb-14" data-aos="fade-up" data-aos-delay="200">
      <span class="font-mono text-[10px] text-accent/40 tracking-widest select-none">///</span>
      <span class="text-accent font-mono text-sm">01</span>
      <h2 class="text-3xl sm:text-4xl font-display font-black text-text-strong">
        {{ "about.title" | translate }}
      </h2>
      <span class="flex-1 h-px bg-subtle"></span>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)] gap-12 items-start">
      <!-- Left: Services / What I Do -->
      <div class="space-y-4" data-aos="fade-up" data-aos-delay="200">
        @for (service of services; track $index) {
          <div class="bg-surface-100/60 border border-subtle rounded-xl p-5 hover:border-accent/20 transition-colors duration-300">
            <div class="flex items-center gap-3 mb-2">
              <span class="w-9 h-9 rounded-lg bg-accent/10 border border-accent/20 text-accent flex items-center justify-center text-sm">
                <i [class]="service.icon" aria-hidden="true"></i>
              </span>
              <h3 class="text-base font-display font-bold text-text-strong">
                {{ service.title }}
              </h3>
            </div>
            <p class="text-sm text-muted-light leading-relaxed pl-12">
              {{ service.description }}
            </p>
          </div>
        }
      </div>

      <!-- Right: Bio + Stats -->
      <div [attr.data-aos]="isMobile ? 'fade-up' : 'fade-left'" data-aos-delay="300">
        <div class="text-muted-light text-base leading-relaxed space-y-4">
          <p>{{ "about.presentation" | translate }}</p>
          <p>{{ "about.mission" | translate }}</p>
          <p class="text-accent/80 font-display font-medium text-sm border-l-2 border-accent/30 pl-4">
            {{ "about.calltoaction" | translate }}
          </p>
        </div>

        <!-- Stats -->
        <div class="mt-10 grid grid-cols-3 gap-6" data-aos="fade-up" data-aos-delay="400">
          <div class="text-center lg:text-left">
            <span class="text-3xl font-display font-black text-accent">5+</span>
            <p class="mt-1 text-[10px] font-mono uppercase tracking-[0.2em] text-muted">{{ 'about.stats.years' | translate }}</p>
          </div>
          <div class="text-center lg:text-left">
            <span class="text-3xl font-display font-black text-accent">10+</span>
            <p class="mt-1 text-[10px] font-mono uppercase tracking-[0.2em] text-muted">{{ 'about.stats.projects' | translate }}</p>
          </div>
          <div class="text-center lg:text-left">
            <span class="text-3xl font-display font-black text-accent">100%</span>
            <p class="mt-1 text-[10px] font-mono uppercase tracking-[0.2em] text-muted">{{ 'about.stats.commitment' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
